<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" class="mr-2 mt-2">
        <v-card elevation="0" height="88vh" class="main-dashboard-115-card body-card">
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12">
                <v-row>
                  <v-col cols="3">
                    <v-card height="15vh" class="data-card1" elevation="0">
                      <v-card-text>
                        <v-row no-gutters>
                          <v-col cols="2">
                            <v-icon color="darkColor" class="data-card-icon">
                              mdi-clock-time-four mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="2" class="mr-3">
                            <h2 class="data-card-title">ساعت کاری</h2>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col cols="5">
                            <h2 class="data-card-content">
                              {{ dashboardDoctorTime }}
                            </h2>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="3">
                    <v-card height="15vh" class="data-card2" elevation="0">
                      <v-card-text>
                        <v-row no-gutters>
                          <v-col cols="2">
                            <v-icon color="darkColor" class="data-card-icon">
                              mdi-car-emergency mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="5" class="mr-3">
                            <h2 class="data-card-title">پرونده های مشاوره ای</h2>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col cols="2" class="text-left ml-2">
                            <h2 class="data-card-content">
                              {{ dashboardDoctorConsultantMissionCount }}
                            </h2>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="3">
                    <v-card height="15vh" class="data-card3" elevation="0">
                      <v-card-text>
                        <v-row no-gutters>
                          <v-col cols="2">
                            <v-icon color="darkColor" class="data-card-icon">
                              mdi-car-emergency mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="5" class="mr-3">
                            <h2 class="data-card-title">تعداد تماس ها</h2>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col cols="2" class="text-left ml-2">
                            <h2 class="data-card-content">
                              {{ dashboardDoctorCallsCount }}
                            </h2>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="3">
                    <v-card height="15vh" class="data-card4" elevation="0">
                      <v-card-text>
                        <v-row no-gutters>
                          <v-col cols="2">
                            <v-icon color="darkColor" class="data-card-icon">
                              mdi-car-emergency mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="5">
                            <h2 class="data-card-title pr-2">میانگین زمان مکالمه</h2>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col cols="5" class="text-left">
                            <h2 class="data-card-content">
                              {{ dashboardDoctorResponseTimeAverage }}
                            </h2>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card height="37vh" class="detail-115-dashboard-card" elevation="0">
                      <v-row no-gutters class="chart-title">
                        <v-icon color="white" class="chart-title-icon">
                          mdi-clipboard-list mdi-48px
                        </v-icon>
                        <span class="chart-title-content">دارو های تجویزی</span>
                      </v-row>
                      <v-card-text>
                        <div id="dashboardDoctorColumnDrugChart" style="width: inherit">
                          <highcharts :options="dashboardDoctorColumnDrugChartOptions"
                            ref="dashboardDoctorColumnDrugChart"></highcharts>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <!-- //غیرفعال کردن نمودار به دلیل عدم نیاز در داشبورد پزشک -->
                  <!-- <v-col cols="4">
                    <v-card height="37vh" class="detail-115-dashboard-card" elevation="0">
                      <v-row no-gutters class="chart-title">
                        <v-icon color="white" class="chart-title-icon">mdi-cog mdi-48px</v-icon>
                        <span class="chart-title-content">نتیجه تماس ها</span>
                      </v-row>
                      <v-card-text>
                        <div id="dashboardDoctorPieChart" dir="rtl" style="width: inherit">
                          <highcharts :options="dashboardDoctorPieChartOptions" ref="pie"></highcharts>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col> -->
                  <v-col cols="12">
                    <v-card height="35vh" class="detail-115-dashboard-card" elevation="0">
                      <v-row no-gutters class="chart-title">
                        <v-icon color="white" class="chart-title-icon">
                          mdi-clipboard-list mdi-48px
                        </v-icon>
                        <span class="chart-title-content">تشخیص ها</span>
                      </v-row>
                      <v-card-text>
                        <div id="dashboardDoctorColumnDiagnosisChart" style="width: inherit">
                          <highcharts :options="dashboardDoctorColumnDiagnosisChartOptions"
                            ref="dashboardDoctorColumnDiagnosisChart"></highcharts>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import AlertComponent from '../../components/AlertComponent.vue';

import DashboardDoctorHelper from '@/Helpers/Doctor/DashboardDoctorHelper.js';
import SharedHelper from '@/Helpers/Shared';
import DashboardMixin from '@/Mixins/Dashboard/DashboardMixin.js';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
export default {
  name: 'DashboardDoctorView',
  title: 'داشبورد پزشک',
  components: { AlertComponent },
  mixins: [DashboardDoctorHelper, SharedHelper, DashboardMixin, snackBar, ShearedMixin],
  created() {
    this.$root.$refs.DashboardDoctor = this;
  },
  mounted() {
    this.mounteLoding();
  },
  beforeDestroy() {
    clearInterval(this.dashboardDoctorTimeInterval);
    this.dashboardDoctorTimeInterval = null;
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      this.getDoctorDashboardFunction();
    },
  },
};
</script>
<style scoped>
.main-dashboard-115-card {
  border-radius: 10px !important;
  border: 1px solid var(--dark-color) !important;
}

.body-card {
  overflow-y: auto;
}

.detail-115-dashboard-card {
  background: var(--background-color) !important;
  border-radius: 15px !important;
}

.data-card1 {
  background: linear-gradient(250deg, var(--dark-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card2 {
  background: linear-gradient(250deg, var(--light-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card3 {
  background: linear-gradient(250deg, var(--one-field-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card4 {
  background: linear-gradient(250deg, var(--new-call-effect) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

>>>.highcharts-credits {
  /*color: black !important;*/
  fill: var(--background-color) !important;
  cursor: auto !important;
}

>>>.highcharts-background {
  fill: var(--background-color) !important;
}

>>>.highcharts-legend-item text {
  fill: var(--dark-color) !important;
}

>>>.highcharts-label span {
  fill: var(--dark-color) !important;
  color: var(--dark-color) !important;
  z-index: 1 !important;
}

.data-card-icon {
  background: white;
  padding: 10px !important;
  border-radius: 50% !important;
  margin-top: 2.5vh;
}

.data-card-title {
  color: white;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  padding-top: 3.3vh !important;
  margin-right: -2vh !important;
}

.data-card-content {
  color: white;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  padding-top: 3.5vh !important;
  letter-spacing: 1.3px;
}

.data-card-calls-count-content {
  color: #2d3748;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  padding-top: 2vh !important;
  letter-spacing: 1.3px;
  position: relative !important;
}

.data-card-calls-count-title {
  color: #2d3748;
  font-size: 13px;
  font-style: normal;
  font-weight: normal;
  margin-top: -2vh !important;
  position: relative !important;
}

.chart-title {
  position: absolute;
}

.chart-title-content {
  margin-right: -50px;
  margin-top: 8px;
  font-weight: 500;
  font-size: 15px;
  z-index: 1;
  color: var(--dark-color);
}

.chart-title-icon {
  z-index: 1;
  margin-right: 10px;
  margin-top: 4px;
}
</style>
